import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { RefuseBatchParticipationPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const refuseBatchPayment = createApiThunk<void, RefuseBatchParticipationPaymentBody>(
  "batchPayments/refuseBatchPayment",
  async (data, { extra: { adminRepository } }) => {
    return adminRepository!.refusePayment(data);
  },
);

export const resetRefuseBatchPayment = createAction("batchPayments/resetRefuseBatchPayment");
